<template>
    <div id="IframeModal">
        <div class="bg"></div>
        <div class="content">
            <iframe :src="iframeSrc" frameborder="0" v-if=""></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: "IframeModal",
    props: {
        iframeSrc: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
#IframeModal {
    .bg {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.25);
        z-index: 1000;
    }

    .content {
        left: 0;
        top: 0;
        position: fixed;
        width: 100%;
        max-width: 90%;
        height: 100%;
        max-height: 90%;
        z-index: 1001;
    }

    iframe {
        width: 100%;
        height: 100%;
    }
}

</style>
